import { Component, ElementRef, ViewChild } from '@angular/core';
import { ModalsComponent } from 'src/app/common/modals/modals.component';
import { ToastComponent } from 'src/app/common/toast/toast.component';
import {
  SidebarComponent,
  SidebarLink,
} from 'src/app/common/internal-sidebar/internal-sidebar.component';
import { ModalsService } from 'src/app/services/Modals/modals.service';
import { ToastService } from 'src/app/services/Toast/toast.service';
import { FooterComponent } from 'src/app/common/templates/footer/footer.component';
import { HeaderComponent } from 'src/app/common/templates/header/header.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-template',
  imports: [
    FooterComponent,
    HeaderComponent,
    ModalsComponent,
    RouterOutlet,
    SidebarComponent,
    ToastComponent,
  ],
  templateUrl: './template.component.html',
  styleUrl: './template.component.scss',
})
export class TemplateComponent {
  @ViewChild('modals', { static: true }) modalsComponent!: ModalsComponent;
  @ViewChild('toast', { static: true }) toastComponent!: ToastComponent;
  @ViewChild('sidebar', { static: true, read: ElementRef })
  sidebar!: ElementRef;
  navLinks!: SidebarLink[];

  constructor(private modals: ModalsService, private toast: ToastService) {}
  ngOnInit() {
    this.modals.bindComponent(this.modalsComponent);
    this.toast.bindComponent(this.toastComponent);
    this.initSidebar();
  }
  initSidebar() {
    this.navLinks = [
      // hide for now until have data
      // {
      //   name: 'Dashboard',
      //   icon: 'bi-house',
      //   url: '/csr'
      // },
      {
        name: 'Inquiries',
        icon: 'bi-chat-left-text',
        url: '/csr/inquiries',
      },
      {
        name: 'Manage FAQs',
        icon: 'bi-question-circle',
        url: '/csr/manage-faq',
      },
    ];
  }
  showSidebar() {
    this.sidebar?.nativeElement.focus();
  }
}
